export enum PakMenuKeys {
  OpenQuote = 'openQuote',
  CreateRevision = 'createRevision',
  CreateCopy = 'createCopy',
  CreateSisterPack = 'createSisterPack',
  CreateLocalContract = 'createLocalContract',
  RouteQuote = 'routeQuote',
  ViewRoutingHistory = 'viewRoutingHistory',
  RespondToRequest = 'respondToRequest',
  TakeOwnership = 'takeOwnership',
  GenerateDocument = 'generateDocument',
  ArchivePack = 'archivePack',
  UnarchivePack = 'unarchivePack',
  Properties = 'properties',
  MakeContract = 'makeContract',
  MakePrototype = 'makePrototype',
  AssignAccount = 'assignAccount',
  DeleteQuote = 'deleteQuote',
  SendToIrisStaging = 'sendToIrisStaging',
  SaveToSalesforce = 'saveToSalesforce',
  ClearInbox = 'clearInbox',
  TransferOwnership = 'transferOwnership',
}

export enum createPakKeys {
  RevisionFromThisPack = 'revisionFromThisPack',
  CopyFromThisPack = 'copyFromThisPack',
  SisterPackFromThisPack = 'sisterPackFromThisPack',
  LocalContractFromThisPack = 'localContractFromThisPack',
  FromExistingPack = 'fromExistingPack',
  FromTemplate = 'fromTemplate',
  FromScratch = 'fromScratch',
  SmartRevisions = 'smartRevisions',
}
